import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const EcommFlashIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M12.8821 2.75108C12.8807 2.75138 12.8551 2.7568 12.8157 2.80749L5.81741 11.7904C5.74607 11.882 5.72827 12.0156 5.77784 12.1395C5.82722 12.2629 5.88814 12.2651 5.90036 12.2651H9.3042C10.298 12.2651 10.9528 13.1438 10.9528 14.0301V20.983C10.9528 21.1612 11.0397 21.2263 11.0782 21.2427C11.1003 21.2521 11.1131 21.2502 11.1178 21.249L11.1179 21.249C11.1193 21.2487 11.1448 21.2433 11.1843 21.1926L18.1826 12.2097C18.2539 12.1181 18.2717 11.9845 18.2222 11.8606C18.1728 11.7372 18.1119 11.735 18.0997 11.735H14.6958C13.702 11.735 13.0472 10.8563 13.0472 9.96999V3.01712C13.0472 2.83893 12.9603 2.77383 12.9218 2.75739C12.8997 2.74799 12.8869 2.74989 12.8822 2.75106L12.8821 2.75108ZM13.5099 1.37751C14.1211 1.63803 14.5472 2.25947 14.5472 3.01712V9.96999C14.5472 10.0715 14.5836 10.1473 14.622 10.1906C14.6591 10.2325 14.6866 10.235 14.6958 10.235H18.0997C18.8607 10.235 19.3925 10.7478 19.6148 11.3033C19.8369 11.8583 19.8054 12.5674 19.3659 13.1315L12.3676 22.1145C11.8782 22.7427 11.1179 22.8902 10.4901 22.6226C9.87887 22.3621 9.4528 21.7406 9.4528 20.983V14.0301C9.4528 13.9287 9.41641 13.8529 9.37805 13.8095C9.34093 13.7676 9.3134 13.7651 9.3042 13.7651H5.90036C5.13934 13.7651 4.60754 13.2523 4.38523 12.6968C4.16312 12.1419 4.19464 11.4327 4.63412 10.8686L11.6324 1.88563C12.1218 1.25741 12.8821 1.10991 13.5099 1.37751Z"
            fill="#222"
            fillRule="evenodd"
            clipRule="evenodd"
          />
        </svg>
      </IconWrapper>
    )
  },
)
